import { render, staticRenderFns } from "./CustomerComponent.vue?vue&type=template&id=bf9e45f2&scoped=true"
import script from "./CustomerComponent.vue?vue&type=script&lang=js"
export * from "./CustomerComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerComponent.vue?vue&type=style&index=0&id=bf9e45f2&prod&lang=css"
import style1 from "./CustomerComponent.vue?vue&type=style&index=1&id=bf9e45f2&prod&lang=scss"
import style2 from "./CustomerComponent.vue?vue&type=style&index=2&id=bf9e45f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9e45f2",
  null
  
)

export default component.exports